export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9556.ff2fa151.jpg";